import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import UU5 from "uu5g04";
import "uu5g04-bricks";

import ns from "ns";

import "./block.less";

export const Block = createReactClass({
  //@@viewOn:mixins
  mixins: [
    UU5.Common.BaseMixin,
    UU5.Common.ElementaryMixin,
    UU5.Common.NestingLevelMixin,
    UU5.Common.ScreenSizeMixin,
    UU5.Common.SectionMixin,
    UU5.Common.EditableMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: ns.tag("Bricks.Block"),
    nestingLevelList: UU5.Environment.getNestingLevelList("bigBoxCollection", "box"),
    classNames: {
      main: ns.css("bricks-block"),
      info: ns.css("bricks-block-info"),
      danger: ns.css("bricks-block-danger"),
      success: ns.css("bricks-block-success"),
      warning: ns.css("bricks-block-warning"),
      default: ns.css("bricks-block-default"),
      help: ns.css("bricks-block-help"),
      icon: ns.css("bricks-icon-table-cell"),
      iconContentContainer: ns.css("bricks-icon-content-table-cell"),
      iconContent: ns.css("bricks-icon-content"),
      content: ns.css("bricks-content")
    },
    editableComponent: ns.tag("BricksEditable.Block")
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    type: PropTypes.string,
    icon: PropTypes.string,
    iconContent: PropTypes.string,
    content: PropTypes.oneOfType([
      PropTypes.array, PropTypes.string
      ]),
    header: PropTypes.string,
    footer: PropTypes.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps

  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getChild() {
    if (this.isXs()) {
      return this._getSmallBlock();
    } else {

      // prefer iconContent over icon
      if (this.props.iconContent) {
        return this._getBigBlockText(this.props.iconContent);
      }

      let icon;
      switch (this.props.type) {
        case "info":
          icon = this.props.icon || "mdi-information";
          break;
        case "success":
          icon = this.props.icon || "mdi-checkbox-marked-circle";
          break;
        case "warning":
          icon = this.props.icon || "mdi-alert";
          break;
        case "danger":
          icon = this.props.icon || "mdi-alert-circle";
          break;
        case "help":
          icon = this.props.icon || "mdi-help-circle";
          break;
        case "default":
          icon = this.props.icon || "mdi-bowling";
          break;
      }
      return this._getBigBlockIcon(icon);
    }
  },

  _getSmallBlock() {
    return (
      <UU5.Bricks.Div>
        {this.getHeader() ? this.getHeaderChild() : null}
        <UU5.Bricks.Div {...this.getMainPropsToPass()} content={null} header={null} footer={null}>
          <UU5.Bricks.Div className={this.getClassName(this.props.type)}>
            <UU5.Bricks.Div className={this.getClassName("content")}
                            content={this.props.content || this.props.children}/>
          </UU5.Bricks.Div>
        </UU5.Bricks.Div>
        {this.getFooter() ? this.getFooterChild() : null}
      </UU5.Bricks.Div>
    );
  },

  _getBigBlockIcon(icon) {
    return (
      <UU5.Bricks.Div>
        {this.getHeader() ? this.getHeaderChild() : null}
        <UU5.Bricks.Div {...this.getMainPropsToPass()} content={null} header={null} footer={null}>
          <UU5.Bricks.Div className={this.getClassName(this.props.type)}>
            <UU5.Bricks.Span className={this.getClassName("icon")}>
              <UU5.Bricks.Icon icon={icon} />
            </UU5.Bricks.Span>
            <UU5.Bricks.Div className={this.getClassName("content")}
                            content={this.props.content || this.props.children} />
          </UU5.Bricks.Div>
        </UU5.Bricks.Div>
        {this.getFooter() ? this.getFooterChild() : null}
      </UU5.Bricks.Div>
    );
  },

  _getBigBlockText(text) {
    return (
      <UU5.Bricks.Div>
        {this.getHeader() ? this.getHeaderChild() : null}
        <UU5.Bricks.Div {...this.getMainPropsToPass()} content={null} header={null} footer={null}>
          <UU5.Bricks.Div className={this.getClassName(this.props.type)}>
            <UU5.Bricks.Span className={this.getClassName("iconContentContainer")}>
              <UU5.Bricks.Div className={this.getClassName("iconContent")}>
                <UU5.Bricks.Div content={text} />
              </UU5.Bricks.Div>
            </UU5.Bricks.Span>
            <UU5.Bricks.Div className={this.getClassName("content")} content={this.props.content || this.props.children} />
          </UU5.Bricks.Div>
        </UU5.Bricks.Div>
        {this.getFooter() ? this.getFooterChild() : null}
      </UU5.Bricks.Div>
    );
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function() {
    return this.getNestingLevel() ? this._getChild() : null;
  }
  //@@viewOff:render
});

export default Block;



// WEBPACK FOOTER //
// ./bricks/block.js